import { OfflineOpStatus, OfflineOperation } from './offline-storage.service';

export interface PendingSubmissionRow {
  operationId: string;
  tkt: string;
  orderNumber: string;
  folio: string;
  operationType: OfflineOperation['type'];
  operationLabel: string;
  queuedAt: number;
  retryCount: number;
  lastAttemptAt?: number;
  status: OfflineOpStatus;
  lastErrorMessage?: string;
  userRut?: string;
}

export const OFFLINE_OP_LABELS: Record<OfflineOperation['type'], string> = {
  statusUpdate: 'Cambio de estado',
  extraValues: 'Observaciones / adicionales',
  extraField: 'Observación / adicional',
  unsigned: 'Guía no firmada',
  clearPending: 'Cierre de despacho pendiente',
  signed: 'Firma en papel',
  signedCanvas: 'Firma digital',
  rejected: 'Rechazo de guía',
};

export const OFFLINE_OP_STATUS_LABELS: Record<OfflineOpStatus, string> = {
  pending: 'Pendiente',
  syncing: 'Enviando',
  failed: 'Fallido',
  blocked: 'Bloqueado',
  paused: 'Pausado',
};

export const TERMINAL_OFFLINE_OP_TYPES: OfflineOperation['type'][] = [
  'signedCanvas',
  'signed',
  'unsigned',
  'clearPending',
  'rejected',
];
